module.exports = ""


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/components/controlPanel.html
 ** module id = 238
 ** module chunks = 1
 **/